import { render, staticRenderFns } from "./InputInfo.vue?vue&type=template&id=49bb6130&scoped=true&"
import script from "./InputInfo.vue?vue&type=script&lang=js&"
export * from "./InputInfo.vue?vue&type=script&lang=js&"
import style0 from "./InputInfo.vue?vue&type=style&index=0&id=49bb6130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb6130",
  null
  
)

export default component.exports